import { useQuery } from '@tanstack/react-query';
import { fetchQuestionBankTopicDetail } from '../services/questionBankTopicService';

export function useQuestionBankTopicDetail(params = {}, options = {}) {
  return useQuery({
    queryKey: ['questionBankTopicDetail', params],
    queryFn: async () => {
      const { payload } = await fetchQuestionBankTopicDetail(params);
      const topicDetail = payload?.topic_detail || payload?.topicDetail || payload || null;

      return topicDetail
        ? {
            ...topicDetail,
            topicDetail,
          }
        : null;
    },
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });
}
